
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h6>{` `}</h6>
    <h1>{`Cookie policy`}</h1>
    <h2>{`Algemeen`}</h2>
    <p>{`Deze cookie policy regelt het gebruik van cookies en soortgelijke technologieën als onderdeel van
uw gebruik van onze website en de bijbehorende diensten. Deze verwerking wordt uitgevoerd door
Partena Professional als verantwoordelijke voor de verwerking, met zetel te Kartuizerstraat 45, 1000
Brussel in overeenstemming met de toepasselijke wetgeving inzake de bescherming van persoonsgegevens.`}</p>
    <p>{`Cookies zijn kleine tekstbestanden die op de harde schijf van een toestel worden opgeslagen en bepaalde informatie bevatten, waaronder soms ook persoonsgegevens. Wanneer u onze Website en/of Diensten gebruikt, verzamelen en verwerken wij ook andere persoonlijke informatie dan via cookies en soortgelijke technologieën. Als u meer wilt weten, lees dan onze Privacy Policy.`}</p>
    <p><strong parentName="p">{` Door gebruik te blijven maken van onze website en/of diensten of door op `}{`"`}{`verdergaan`}{`"`}{` te klikken nadat u op de hoogte bent gesteld van het gebruik van cookies en soortgelijke technologieën, erkent u dat u deze Cookie Policy zorgvuldig heeft gelezen en dat u ermee instemt zonder voorbehoud. Zoals uiteengezet in deze Cookie Policy kunt u uw cookie-voorkeuren te allen
tijde wijzigen. `}</strong></p>
    <p>{`Wij behouden ons het recht voor deze Cookie Policy van tijd tot tijd te wijzigen, aan te vullen of te vervangen. Dergelijke wijzigingen, toevoegingen of vervangingen zullen onder uw aandacht worden
gebracht via onze website en/of diensten. Als u het niet eens bent met deze wijzigingen, toevoegingen of vervangingen, vragen wij u een e-mail te sturen naar `}<u><a parentName="p" {...{
          "href": "mailto:privacy@partena.be"
        }}>{`privacy@partena.be`}</a></u>{`. Indien
wij hiervan geen mededeling hebben ontvangen binnen drie (3) werkdagen nadat de wijzigingen,
aanvullingen of vervangingen via onze website of diensten aan u zijn meegedeeld, wordt u geacht
alle wijzigingen, aanvullingen of vervangingen te hebben aanvaard.`}</p>
    <h2>{`Welke cookies en waarom`}</h2>
    <p>{`Wanneer u onze website bezoekt en/of gebruikt, plaatsen wij cookies of gebruiken we soortgelijke
technologieën waarmee we persoonsgegevens over u verzamelen en verwerken. Dergelijke cookies
en soortgelijke technologieën omvatten onder meer:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Naam`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Doel`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Bewaartermijn`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`dc_gtm_UA-#`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistisch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Tag Manager - Gebruikt voor het inladen van Google Analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 dag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`ga`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistisch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Analytics - Registreert een unieke ID die wordt gebruikt om statistische gegevens te genereren over hoe de bezoeker de website gebruikt`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`gat`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistisch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Analytics - Gebruikt door Google Analytics om het aantal aanvragen te beperken`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 dag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`gid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistisch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Tag Manager - Registreert een unieke ID die wordt gebruikt om statistische gegevens te genereren over hoe de bezoeker de website gebruikt`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 dag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`vwo_uuid_v2`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistisch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`VWO - Gebruikt voor het tonen van splittesten voor de optimalisatie van de website`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`fbp`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Facebook - Gebruikt door Facebook om een serie van advertentieproducten te leveren, zoals real time biedingen van externe adverteerders`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 dag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjDonePolls`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Onthoudt of de bezoeker eerder heeft gereageerd op een bepaald formulier`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjIncludedInSample`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Onthoudt of de bezoeker meegenomen is in een samplingrapport`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Registreert een unieke ID die wordt gebruikt om statistische gegevens te genereren over hoe de bezoeker de website gebruikt`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Fr`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Facebook - Gebruikt door Facebook om een serie van advertentieproducten te leveren, zoals real time biedingen van derden`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`3 maanden`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`#Visitor_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pardot - De waarde die via de cookie wordt opgeslagen is een unieke ID voor de bezoeker`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`10 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`lang`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Gebruikt door Linkedin om de geselecteerde taal van de gebruiker bij te houden`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sessie`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bcookie`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Gebruikt door Linkedin voor het meten van Linkedin embeds`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bscookie`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Gebruikt door Linkedin voor het meten van Linkedin embeds`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`lidc`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Gebruikt door Linkedin voor het optimaliseren van advertentievertoningen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 dag`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UserMatchHistory`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Gebruikt door Linkedin voor het optimaliseren van advertentievertoningen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`29 dagen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adform - Gebruikt door Adform voor het optimaliseren van advertentievertoningen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 maanden`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`uid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adform - Gebruikt door Adform voor het optimaliseren van advertentievertoningen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 maanden`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjTLDTest`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Gebruikt door Hotjar voor het registreren van gebruik op subdomeinen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sessie`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pctrk`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistisch`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pardot - Gebruikt door Pardot voor het bijhouden van openbare paginaweergaven.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jaar`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`NG_TRANSLATE_LANG_KEY`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Functioneel`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pardot - Gebruikt door Pardot voor het bijhouden van de taalselectie`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sessie`}</td>
        </tr>
      </tbody>
    </table>
    <h6>{` `}</h6>
    <p>{`U kunt voorkomen dat cookies worden geplaatst of reeds geplaatste cookies verwijderen door uw
instellingen in uw browser aan te passen. Hulp bij het aanpassen van deze instellingen kunt u vinden
op de website van de browser die u gebruikt. Houd er rekening mee dat het niet toestaan van
cookies bij het bezoeken van de website ertoe kan leiden dat sommige of alle functies van de
website niet naar behoren werken.`}</p>
    <ul>
      <li parentName="ul">{`Internet Explorer: `}<u><a parentName="li" {...{
            "href": "https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
          }}>{`https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies`}</a></u></li>
      <li parentName="ul">{`Microsoft Edge: `}<u><a parentName="li" {...{
            "href": "http://windows.microsoft.com/en-gb/windows-10/edge-privacy-faq"
          }}>{`http://windows.microsoft.com/en-gb/windows-10/edge-privacy-faq`}</a></u></li>
      <li parentName="ul">{`Chrome: `}<u><a parentName="li" {...{
            "href": "https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=nl"
          }}>{`https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop`}{`&`}{`hl=nl`}</a></u></li>
      <li parentName="ul">{`Firefox: `}<u><a parentName="li" {...{
            "href": "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
          }}>{`https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences`}</a></u></li>
      <li parentName="ul">{`Safari: `}<u><a parentName="li" {...{
            "href": "https://support.apple.com/nl-be/guide/safari/sfri11471/mac"
          }}>{`https://support.apple.com/nl-be/guide/safari/sfri11471/mac`}</a></u></li>
    </ul>
    <p>{`Als u een klacht heeft over de verwerking van uw persoonsgegevens door ons, kunt u altijd contact
met ons opnemen via het e-mailadres `}<u><a parentName="p" {...{
          "href": "mailto:privacy@partena.be"
        }}>{`privacy@partena.be`}</a></u>{`. Blijft u ontevreden over ons antwoord,
dan staat het u vrij om een klacht in te dienen bij de bevoegde gegevensbeschermingsautoriteit, de
Belgische Gegevensbeschermingsautoriteit, Drukpersstraat 35, 1000 Brussel, Tel +32 (0)2 274 48 00,
website: `}<u><a parentName="p" {...{
          "href": "www.gegevensbeschermingsautoriteit.be"
        }}>{`www.gegevensbeschermingsautoriteit.be`}</a></u>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;